import { render, staticRenderFns } from "./relatedTransactionNumber.vue?vue&type=template&id=10c8663f&scoped=true&"
import script from "./relatedTransactionNumber.vue?vue&type=script&lang=js&"
export * from "./relatedTransactionNumber.vue?vue&type=script&lang=js&"
import style0 from "./relatedTransactionNumber.vue?vue&type=style&index=0&id=10c8663f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c8663f",
  null
  
)

export default component.exports